module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "textcontainer"
  }, [_c('tech')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c1c72096","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tech.vue
// module id = 205
// module chunks = 0